export var FertilizationMethod;
(function (FertilizationMethod) {
    FertilizationMethod["AtSoil"] = "1";
    FertilizationMethod["Fertigation"] = "2";
})(FertilizationMethod || (FertilizationMethod = {}));
